module.exports = __webpack_public_path__ + "static/media/headerLogo.9dae42ce.png";